import { render } from "./OrderCreateBattery.vue?vue&type=template&id=1028c236"
import script from "./OrderCreateBattery.vue?vue&type=script&lang=js"
export * from "./OrderCreateBattery.vue?vue&type=script&lang=js"

import "./OrderCreateBattery.vue?vue&type=style&index=0&id=1028c236&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__